import { render, staticRenderFns } from "./BackgroundLayers.vue?vue&type=template&id=6831e290"
import script from "./BackgroundLayers.vue?vue&type=script&lang=js"
export * from "./BackgroundLayers.vue?vue&type=script&lang=js"
import style0 from "./BackgroundLayers.vue?vue&type=style&index=0&id=6831e290&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports